export const DATA_SLUG = 'data-slug';
export const DATA_MODEL = 'data-model';
export const DATA_LOCALE = 'data-locale';
export const DATA_CATEGORY = 'data-category';
export const DATA_SUBCATEGORY = 'data-subcategory';

export const getBodyAttributes = (doc?: any) => {
  if (!doc) {
    return {};
  }
  const subcategoryObject = doc?.subCategory;
  const subcategory = subcategoryObject?.slug;
  const category = subcategoryObject?.category?.slug;
  return {
    [DATA_SLUG]: doc.slug,
    [DATA_MODEL]: doc.__typename,
    [DATA_LOCALE]: doc.locale,
    [DATA_CATEGORY]: category,
    [DATA_SUBCATEGORY]: subcategory,
  };
};
